import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import I18n from 'I18n';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import debounce from 'transmute/debounce';
import { useAssociatedObjectsCardRedesignContext } from '../../../context/AssociatedObjectsCardRedesignContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ANIMATION_DURATION = 300;
const SearchInputWrapper = styled.div.withConfig({
  displayName: "AssociationsSearchInput__SearchInputWrapper",
  componentId: "ym6mxf-0"
})(["max-height:", ";opacity:", ";transform:", ";transition:max-height ", "ms ease-out,opacity 200ms ease-out,transform ", "ms ease-out;overflow:", ";"], ({
  isVisible
}) => isVisible ? '56px' : '0', ({
  isVisible
}) => isVisible ? '1' : '0', ({
  isVisible,
  theme
}) => isVisible ? 'translateY(0)' : `translateY(-${theme.space['250']})`, ANIMATION_DURATION, ANIMATION_DURATION, ({
  isVisible
}) => isVisible ? 'visible' : 'hidden');
function AssociationSearchInput({
  showSearchInput
}) {
  const {
    onSearchQueryChange
  } = useAssociatedObjectsCardRedesignContext();
  const [inputValue, setInputValue] = useState('');
  const debouncedSearch = useMemo(() => debounce(300, onSearchQueryChange), [onSearchQueryChange]);
  const handleInputChange = e => {
    setInputValue(e.target.value);
    debouncedSearch(e.target.value);
  };
  useEffect(() => {
    if (showSearchInput) {
      setInputValue('');
    } else {
      //Timeout to sync input clearing with fade-out animation (reducing visual jitter)
      const timeout = setTimeout(() => {
        setInputValue('');
      }, ANIMATION_DURATION);
      return () => clearTimeout(timeout);
    }
  }, [showSearchInput]);
  return /*#__PURE__*/_jsx(SearchInputWrapper, {
    isVisible: showSearchInput,
    children: /*#__PURE__*/_jsx(SearchInput, {
      placeholder: I18n.text('cardAssociatedObjects.AssociatedObjectsCardSearch.searchPlaceholder'),
      onChange: handleInputChange,
      value: inputValue,
      marginBlockStart: "300"
    })
  });
}
export default AssociationSearchInput;